// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7980":"afd33fb7e077bb00","92888":"094541d543369565"}[chunkId] + ".css";
};